import "../ConnectionComponent/Connection.css";

export default function ConnectionTimeout(props: { onRetry: () => void }) {
  return (
    <div className="connection">
      <h2>Não conseguimos conectar</h2>
      <p>Verifique sua conexão de internet e as permissões de câmera e microfone, e tente novamente.</p>
      <button onClick={props.onRetry}>Tentar novamente</button>
    </div>
  );
}
